var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["createReadableStreamWrapper"]: () => __WEBPACK_EXTERNAL_MODULE__mattiasbuelens_web_streams_adapter_7d231298__.createReadableStreamWrapper });